<template>
  <div class="video-call">
    <!-- <div class="list">
      <a-empty description="暂无成员在线" v-if="video.length === 0"/>
      <div class="video-item" :class="'num-' + (video.length > 4 ? 5: video.length) + ' ' + item.detail.full " :id="item.id_" v-for="(item, index) in video" :key="index">
        <div class="name">{{ item.detail.name }}</div>
        <div class="btn">
          <img v-if="item.detail.voiceState === 1" src="../assets/icon_call_voice.png" alt="">
          <img class="click" @click="_fullVideo(index)" src="../assets/icon_call_full.png" alt="">
        </div>
      </div>
    </div> -->
    <div class="video-grid">
      <a-empty description="暂无成员在线" v-if="video.length === 0"/>
      <div class="video-item" :id="item.id_" v-for="(item, index) in video" @click="_oneVideo(index)" :key="index">
        <div class="name">{{ item.detail.name }}</div>
      </div>
    </div>
    <footer>
      <div class="l">
        <button class="click" @click="_openCourt">案件材料</button><button v-if="cmember.memberType === 3" class="click" @click="_sendSign">发起签名</button><button class="click" @click="_popupHandle({type: 0, event: -1})">开庭纪律</button><button v-if="cmember.memberType === 0 || cmember.memberType === 1 || cmember.memberType === 5 || cmember.memberType === 6" @click="_popupHandle({type: 1, event: -1})" class="click">上传证据材料</button><button @click="_popupHandle({type: 2, event: -1})" class="click">开庭笔录</button><button @click="_popupHandle({type: 4, event: -1})" class="click">笔录日志</button>
      </div>
      <div class="r">
        <button class="click red" @click="_end" v-if="cmember.memberType === 3">结束庭审</button><button class="click" @click="_swicthShare" v-if="cmember.memberType === 3">{{ shareStream !== null ?  '关闭分享': '分享屏幕' }}</button><button class="click" @click="_swicthVideo" v-if="localStream.detail.cameraState !== -1">{{ localStream.detail.cameraState === 1 ? '关闭': '开启' }}视频</button><button class="click" @click="_swicthVoice" v-if="localStream.detail.voiceState !== -1">{{ localStream.detail.voiceState === 1 ? '关闭': '开启' }}语音</button><button v-if="cmember.memberType !== 3" @click="_exit" class="click">退出</button>
      </div>
    </footer>
    <Discipline :status="popupStatus.discipline" @handle="_popupHandle" />
    <UploadFile :userType="cmember.memberType" :id="$route.query.id" :status="popupStatus.uploadFile" @handle="_popupHandle" />
    <CourtRecord :userType="cmember.memberType" :id="$route.query.id" :status="popupStatus.courtRecord" @handle="_popupHandle" />
    <CaseInfo :id="$route.query.id" :status="popupStatus.caseInfo" :infoType="popupStatus.caseInfoType" @handle="_popupHandle"/>
    <RecordLog :id="$route.query.id" :status="popupStatus.recordLog" @handle="_popupHandle" />
  </div>
</template>

<script>
import Recorder from 'js-audio-recorder'
import TRTC from 'trtc-js-sdk'
import { getVideoSign, caseInfo, asr, saveAiText, recording, endRecording } from '@/service/getData'
import Discipline from '@/components/Discipline'
import UploadFile from '@/components/UploadFile'
import CourtRecord from '@/components/CourtRecord'
import CaseInfo from '@/components/CaseInfo'
import RecordLog from '@/components/RecordLog'
export default {
  name: 'VideoCall',
  components: {
    Discipline,
    UploadFile,
    CourtRecord,
    CaseInfo,
    RecordLog
  },
  data () {
    return {
      client: null,
      localStream: {
        detail: {}
      },
      shareStream: null,
      list: [],
      cameraId: null,
      micId: null,
      config: null,
      member: [],
      cmember: {},
      refCount: 0,
      video: [],
      ws: null,
      recordIv: null,
      initError: false,
      wsIv: null,
      popupStatus: {
        discipline: false,
        uploadFile: false,
        courtRecord: false,
        caseInfoType: 2,
        caseInfo: false,
        recordLog: false
      },
      videoOneUserId: ''
    }
  },
  created () {
    this.$store.dispatch('loading', { state: true, text: '正在初始化视频会议' })
  },
  mounted () {
    this.initVideoClient()
  },
  methods: {

    _end () {
      var _this = this
      _this.$confirm({
        title: '现在是否结束庭审?',
        okText: '结束',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          endRecording(_this.$route.query.id).then(res => {
            _this._exit()
          })
        },
        onCancel () {
        }
      })
    },

    _swicthShare () {
      if (this.initError) return
      if (this.shareStream === null || this.shareStream.detail.cameraState === 0) {
        this.openShare()
      } else {
        this.closeShare()
      }
    },

    async openShare () {
      var _this = this
      if (_this.shareStream === null) {
        _this.shareStream = TRTC.createStream({
          screenAudio: true,
          screen: true,
          userId: _this.config.userId
        })
        _this.shareStream.is_share = true
        _this.shareStream.detail = { ..._this.cmember }
      }
      try {
        await _this.shareStream.initialize()
        if (_this.localStream.detail.cameraState === 1) {
          await this.closeVideo()
          setTimeout(() => {
            _this.client.publish(_this.shareStream)
          }, 100)
        } else {
          _this.client.publish(_this.shareStream)
        }
        _this.addMember(_this.shareStream)
      } catch (err) {
        console.log(err)
        _this.shareStream = null
      }
    },

    async closeShare () {
      if (this.shareStream !== null) {
        await this.client.unpublish(this.shareStream)
        this.shareStream.close()
        this.shareStream.stop()
        this.shareStream = null
        var idx = this.list.findIndex(e => e.is_share === true)
        this.list.splice(idx, 1)
        this.refreshVideoList()
      }
    },

    _openCourt () {
      this.popupStatus.caseInfoType = -1
      this.popupStatus.caseInfo = true
    },

    /**
     * 发送签名
     */
    _sendSign () {
      if (this.cmember.memberType === 3 && this.ws !== null) {
        this.ws.send(JSON.stringify({
          fromMemberId: this.cmember.id,
          toMemberId: this.cmember.id,
          sendType: 2,
          eventType: 7
        }))
      }
    },

    /**
     * 弹窗事件
     */
    _popupHandle (data) {
      switch (data.type) {
        //  纪律
        case 0:
          if (data.event === -1) {
            this.popupStatus.discipline = !this.popupStatus.discipline
          }
          break
        //  上传文件
        case 1:
          if (data.event === -1) {
            this.popupStatus.uploadFile = !this.popupStatus.uploadFile
          }
          break
        //  笔录
        case 2:
          if (data.event === -1) {
            this.popupStatus.courtRecord = !this.popupStatus.courtRecord
          }
          break
        //  签名二维码
        case 3:
          if (data.event === -1) {
            this.popupStatus.caseInfoType = 2
            this.popupStatus.caseInfo = !this.popupStatus.caseInfo
          }
          break
        //  笔录日志
        case 4:
          if (data.event === -1) {
            this.popupStatus.recordLog = !this.popupStatus.recordLog
          }
          break
      }
    },

    /**
     * 开启循环录音
     */
    initRecord () {
      var _this = this
      _this.startRecord()
      _this.recordIv = setInterval(() => {
        _this.startRecord()
      }, 61000)
    },

    /**
     * 录音
     */
    startRecord () {
      var _this = this
      var member = _this.member.find(e => e.idCard === _this.localStream.userId_)
      const recorder = new Recorder({
        sampleBits: 16,
        sampleRate: 16000,
        numChannels: 1
      })
      recorder.start().then(() => {
        setTimeout(function () {
          recorder.stop()
          var blob = recorder.getWAVBlob()
          var file = new File([blob], 'record.wav')
          asr({
            file: file
          }).then(res => {
            if (res.code === 1) {
              var data = JSON.parse(res.data)
              if (data.code === 0 && !_this.$verify.empty(data.text)) {
                saveAiText({ meetingId: _this.$route.query.id, content: member.info + '：' + data.text })
              }
            }
          })
        }, 60000)
      }, (error) => {
        console.log(`${error.name} : ${error.message}`)
      })
    },

    /**
     * 初始化socket
     */
    initSocket () {
      var _this = this
      var member = _this.member.find(e => e.idCard === _this.localStream.userId_)
      var overtime = 5000
      var serverTimeOut = null
      var msgTimeOut = null
      var openTimeOut = null
      _this.ws = new WebSocket(`wss://api.my-lawcloud.com/wss/ws/${_this.$route.query.id}/${member.id}`)
      _this.ws.onopen = () => {
        openTimeOut = setTimeout(() => {
          console.log('关闭了2')
          _this.ws.close()
        }, 10000)
      }
      _this.ws.onmessage = res => {
        clearTimeout(openTimeOut)
        clearTimeout(msgTimeOut)
        clearTimeout(serverTimeOut)
        var data = {}
        try {
          data = JSON.parse(res.data)
          if (parseInt(data.toMemberId) === member.id || data.sendType === 2) {
            _this.handleSocket(data.eventType)
          }
        } catch (d) {
        }
        msgTimeOut = setTimeout(() => {
          if (_this.ws.readyState === 1) {
            _this.ws.send(1)
            serverTimeOut = setTimeout(() => {
              console.log('关闭了')
              _this.ws.close()
            }, overtime)
          } else {
            console.log('关闭了1')
            _this.ws.close()
          }
        }, overtime)
      }
      _this.ws.onerror = e => {
        _this.ws.close()
      }
      _this.ws.onclose = e => {
        clearTimeout(openTimeOut)
        clearTimeout(msgTimeOut)
        clearTimeout(serverTimeOut)
        setTimeout(() => {
          _this.initSocket()
        }, 3000)
      }
    },

    /**
     * 处理socket消息
     */
    handleSocket (type) {
      switch (type) {
        case 0:
          this.openVoice()
          break
        case 1:
          this.closeVoice(-1)
          break
        case 2:
          this.openVideo()
          break
        case 3:
          this.closeVideo(-1)
          break
        case 4:
          this.closeVoice(-1)
          break
        case 5:
          this.closeVideo(-1)
          break
        case 6:
          console.log('socket-更新笔录')
          break
        case 7:
          this.popupStatus.caseInfo = false
          this._popupHandle({ type: 3, event: -1 })
          break
      }
    },

    /**
     * 音频开关
     */
    _swicthVoice () {
      if (this.localStream.voiceState === 0) {
        this.openVoice()
      } else {
        this.closeVoice()
      }
    },

    /**
     * 关闭录音
     */
    closeVoice (state = 0) {
      if (!this.initError) {
        var idx = this.list.findIndex(e => e.userId_ === this.localStream.userId_)
        this.list[idx].detail.voiceState = state
        this.localStream.voiceState = state
        this.localStream.muteAudio()
        this.refreshVideoList()
      }
    },

    /**
     * 打开录音
     */
    openVoice () {
      if (!this.initError) {
        var idx = this.list.findIndex(e => e.userId_ === this.localStream.userId_)
        this.list[idx].detail.voiceState = 1
        this.localStream.voiceState = 1
        this.localStream.unmuteAudio()
        this.refreshVideoList()
      }
    },

    /**
     * 视频开关
     */
    _swicthVideo () {
      if (this.localStream.cameraState === 0) {
        this.openVideo()
      } else {
        this.closeVideo()
      }
    },

    /**
     * 关闭视频
     */
    async closeVideo (state = 0) {
      if (!this.initError) {
        try {
          await this.client.unpublish(this.localStream)
        } catch (error) {
        }
        var idx = this.list.findIndex(e => e.userId_ === this.localStream.userId_)
        this.list[idx].detail.cameraState = state
        this.list[idx].stop()
        this.localStream.cameraState = state
        this.localStream.muteVideo()
        this.refreshVideoList()
      }
    },

    /**
     * 打开视频
     */
    async openVideo () {
      if (!this.initError) {
        try {
          if (this.shareStream !== null) {
            await this.closeShare()
            setTimeout(() => {
              this.client.publish(this.localStream)
            }, 100)
          } else {
            await this.client.publish(this.localStream)
          }
        } catch (error) {
        }
        var idx = this.list.findIndex(e => e.userId_ === this.localStream.userId_)
        this.list[idx].detail.cameraState = 1
        this.localStream.cameraState = 1
        this.localStream.unmuteVideo()
        this.refreshVideoList()
      }
    },

    /**
     * 退出视频会议
     */
    _exit () {
      this.$router.go(-1)
    },

    /**
     * 初始化成员信息
     */
    async initMember () {
      var res = await caseInfo(this.$route.query.id)
      if (res.code === 1) {
        var arr = res.data.meetingMemberDtoList
        var type = null
        for (var i = 0; i < arr.length; i++) {
          type = this.$util.memberType(arr[i].memberType)
          arr[i].info = arr[i].name + `(${type})`
          arr[i].name = type + '：' + arr[i].name
          // arr[i].sort = this.$util.memberSort(arr[i].memberType)
          // arr[i].full = false
          if (arr[i].idCard === this.config.userId) {
            // arr[i].memberType = 3
            this.cmember = arr[i]
          }
        }
        this.member = arr
      }
      this.handleEvents()
      this.join()
    },

    /**
     * 初始化视频客户端
     */
    async initVideoClient () {
      var res = await getVideoSign()
      if (res.code === 1) {
        this.config = {
          mode: 'rtc',
          sdkAppId: res.data.sdkAppId,
          userId: res.data.userId,
          userSig: res.data.userSig
        }
        TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.NONE)
        this.client = TRTC.createClient(this.config)
        this.initMember()
      }
    },

    /**
     * 加入房间
     */
    async join () {
      var _this = this
      try {
        _this.localStream = TRTC.createStream({
          audio: true,
          video: true,
          userId: _this.config.userId,
          mirror: true
        })
        _this.localStream.detail = { ..._this.cmember }
        _this.localStream.is_share = false
        console.log('debug is ->', _this.$route.query.roomId)
        await _this.client.join({ roomId: parseInt(_this.$route.query.roomId) })
        recording(_this.$route.query.id)
        await _this.localStream.initialize()
        if (_this.cmember.memberType === 10 || _this.localStream.detail.cameraState === 0) {
          _this.localStream.detail.cameraState = -1
          _this.localStream.detail.voiceState = 0
          _this.localStream.muteVideo()
        } else {
          await _this.client.publish(_this.localStream)
        }
        if (_this.localStream.detail.voiceState === 0) {
          _this.localStream.detail.voiceState = -1
          _this.localStream.muteAudio()
        }
      } catch (err) {
        console.log('err is ->', err)
        _this.initError = true
      }
      if (_this.cmember.memberType !== 10) {
        _this.initSocket()
        _this.initRecord()
        _this.addMember(_this.localStream)
      }
      _this.$store.dispatch('loading', { state: false })
    },

    /**
     * 刷新视频列表
     */
    refreshVideoList () {
      var _this = this
      _this.video = [..._this.list.filter(e => { return e.detail.cameraState === 1 })]
      _this.$nextTick(() => {
        _this.refreshVideoDom()
      })
    },

    /**
     * 添加成员
     */
    addMember (stream) {
      var _this = this
      if (!stream.detail) {
        stream.detail = { ..._this.member.find(e => e.idCard === stream.userId_) }
      }
      _this.list.push(stream)
      // _this.list.sort((a, b) => { return a.detail.sort - b.detail.sort })
      _this.refreshVideoList()
      _this.$nextTick(() => {
        _this.refreshVideoDom()
      })
    },

    /**
     * 刷新视频dom 新增 退出等需要操作
     */
    refreshVideoDom () {
      var _this = this
      this.refCount += 1
      var count = _this.refCount
      setTimeout(() => {
        if (_this.refCount === count) {
          for (var i = 0; i < _this.video.length; i++) {
            _this.video[i].stop()
            _this.video[i].play(_this.video[i].getId(), { objectFit: 'contain' })
          }
        }
      }, 1000)
    },

    /**
     * 监听用户状态
     */
    handleEvents () {
      var _this = this
      //  新用户进入房间
      _this.client.on('stream-added', event => {
        var remoteStream = event.stream
        _this.client.subscribe(remoteStream)
      })
      //  新用户订阅成功
      _this.client.on('stream-subscribed', event => {
        const remoteStream = event.stream
        remoteStream.is_share = false

        _this.addMember(remoteStream)
      })
      //  用户关闭音频
      _this.client.on('mute-audio', event => {
        const userId = event.userId
        var idx = _this.list.findIndex(e => e.userId_ === userId)
        if (idx !== -1) {
          _this.list[idx].detail.voiceState = 0
          _this.refreshVideoList()
        }
      })
      //  用户关闭视频
      _this.client.on('mute-video', event => {
        const userId = event.userId
        var idx = _this.list.findIndex(e => e.userId_ === userId)
        if (idx !== -1) {
          _this.list[idx].stop()
          _this.list[idx].detail.cameraState = 0
          _this.refreshVideoList()
        }
      })
      //  用户启用音频
      _this.client.on('unmute-audio', event => {
        const userId = event.userId
        var idx = _this.list.findIndex(e => e.userId_ === userId)
        if (idx !== -1) {
          _this.list[idx].detail.voiceState = 1
          _this.refreshVideoList()
        }
      })
      //  用户启用视频
      _this.client.on('unmute-video', event => {
        const userId = event.userId
        var idx = _this.list.findIndex(e => e.userId_ === userId)
        if (idx !== -1) {
          _this.list[idx].detail.cameraState = 1
          _this.refreshVideoList()
        }
      })
      //  用户被踢出房间
      _this.client.on('client-banned', error => {
        console.error('client-banned observed: ' + error)
        _this.$message.error('您已被踢出房间', () => {
          _this.$router.go(-1)
        })
      })
      //  用户退出房间
      _this.client.on('peer-leave', event => {
        const userId = event.userId
        var index = _this.list.findIndex(e => e.userId_ === userId)
        _this.list[index].stop()
        _this.list.splice(index, 1)
        _this.refreshVideoList()
        _this.$nextTick(() => {
          _this.refreshVideoDom()
        })
      })
    },

    /**
     * 首屏显示
     */
    _oneVideo (idx) {
      if (idx === -1) {
        idx = this.video.findIndex(e => e.userId_ === this.videoOneUserId)
      }
      if (this.videoOneUserId !== this.video[idx].userId_) {
        this.videoOneUserId = this.video[idx].userId_
        var item = this.video[idx]
        this.$set(this.video, idx, this.video[0])
        this.$set(this.video, 0, item)
        this.refreshVideoDom()
      }
    }
  },

  destroyed () {
    this.localStream.close()
    this.client.leave()
    clearInterval(this.recordIv)
    this.ws.onclose = null
    this.ws.close()
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.video-call {
  position: relative;
  width: 100%;
  height: 100%;
  footer {
    height: 8%;
    background-color: #CEE5F9;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 9999;
    button {
      margin: 0 0.15rem;
      font-size: 0.133rem;
      font-family: PingFang SC;
      font-weight: bold;
      padding: 0.1rem 0.15rem;
      border-radius: 0.5rem;
    }
    .l {
      button {
        color: #3D97E6;
      }
    }
    .r {
      button {
        color: #fff;
        background-color: #3D97E6;
      }
      button.red {
        background-color: red;
      }
    }
  }
  .video-grid {
    display: grid;
    height: 92%;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-areas:
        'm m m a b'
        'm m m c d'
        'e f g h i';
    .ant-empty {
      @include center;
    }
    &>div {
      position: relative;
      padding: 10px;
      justify-content: flex-end;
      grid-area: auto / auto / auto / auto;
      flex-direction: column;
      video {
        background-color: #d8d8d8;
      }
      .name {
        @include cl;
        color: #ffffff;
        top: 0.167rem;
        z-index: 2;
        background:rgba(0,0,0,0.5);
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: bold;
        padding: 0 0.15rem;
        line-height: 0.35rem;
      }
      &:first-child {
        justify-content: center;
        grid-area: 1 / 1 / 3 / 4;
      }
    }
  }
}
</style>
